// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ScrollTop_wrap__3BqHa","svg":"ScrollTop_svg__nKcFt","svg_second":"ScrollTop_svg_second__3rnWT","wrap_blue":"ScrollTop_wrap_blue__139Vi"};